export default "__VITE_ASSET__BTWr5lZz__"